export const ActionTypes = {
    START_TIMER: "START_TIMER",
    RESET_STATE: 'RESET_STATE'
};
